import React, { useState } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect } from "react";
import CreateEventModal from "../Events/CreateEventModal";
import { getOverlayLocation } from "./helpers";

export default function MapGeoJsonDrawer({
  features,
  setOverlay,
  onDelete,
}: {
  features?: any;
  setOverlay?: any;
  onDelete?: (feature: any) => void;
}) {
  const map = useMap();

  useEffect(() => {
    if (!map || !features) return;
    map.data.forEach((feature) => {
      map.data.remove(feature);
    });
    features.forEach((feature: any, index: number) => {
      let parsed = null;
      try {
        parsed = JSON.parse(feature);
        const [f] = map.data.addGeoJson(parsed);
        f.setProperty("index", index);
      } catch {
        // malformed entry — skip display
      }
    });

    const bounds = new google.maps.LatLngBounds();
    let hasPoints = false;
    map.data.forEach((feature) => {
      feature.getGeometry()?.forEachLatLng((latLng) => {
        bounds.extend(latLng);
        hasPoints = true;
      });
    });

    map.data.addListener("click", (event: any) => {
      const geometry = event.feature.getGeometry();
      setOverlay({
        show: true,
        position: { x: event.domEvent.x, y: event.domEvent.y },
        content: (
          <div className="p-1 bg-purple-gradient rounded-1">
            <button
              className="btn btn-outline-secondary border-0 w-100 text-start"
              onClick={() => {
                setOverlay((p: any) => ({ ...p, show: false }));
                if (onDelete) {
                  onDelete(event.feature);
                }
              }}
            >
              delete selection
            </button>
          </div>
        ),
      });
    });

    if (hasPoints) {
      map.fitBounds(bounds);
    }
  }, [features, map]);

  return <></>;
}
